// [OBJECT]_[ACTUAL_ACTION]_[REQUEST|SUCCESS|FAILURE]

// USER
export const USER_LOG_IN_REQUEST = 'USER_LOG_IN_REQUEST'
export const USER_LOG_IN_SUCCESS = 'USER_LOG_IN_SUCCESS'
export const USER_LOG_IN_FAILURE = 'USER_LOG_IN_FAILURE'

export const USER_LOG_OUT_REQUEST = 'USER_LOG_OUT_REQUEST'
export const USER_LOG_OUT_SUCCESS = 'USER_LOG_OUT_SUCCESS'
export const USER_LOG_OUT_FAILURE = 'USER_LOG_OUT_FAILURE'

export const USER_LOAD_DATA_REQUEST = 'USER_LOAD_DATA_REQUEST'
export const USER_LOAD_DATA_SUCCESS = 'USER_LOAD_DATA_SUCCESS'
export const USER_LOAD_DATA_FAILURE = 'USER_LOAD_DATA_FAILURE'

// POSTS
export const POSTS_LOAD_REQUEST = 'POSTS_LOAD_REQUEST'
export const POSTS_LOAD_SUCCESS = 'POSTS_LOAD_SUCCESS'
export const POSTS_LOAD_FAILURE = 'POSTS_LOAD_FAILURE'

// PROJECTS
export const PROJECTS_LOAD_REQUEST = 'PROJECTS_LOAD_REQUEST'
export const PROJECTS_LOAD_SUCCESS = 'PROJECTS_LOAD_SUCCESS'
export const PROJECTS_LOAD_FAILURE = 'PROJECTS_LOAD_FAILURE'

// APPS
export const APP_CREATE_REQUEST = 'APP_CREATE_REQUEST'
export const APP_CREATE_SUCCESS = 'APP_CREATE_SUCCESS'
export const APP_CREATE_FAILURE = 'APP_CREATE_FAILURE'

export const APP_DELETE_REQUEST = 'APP_DELETE_REQUEST'
export const APP_DELETE_SUCCESS = 'APP_DELETE_SUCCESS'
export const APP_DELETE_FAILURE = 'APP_DELETE_FAILURE'

export const APP_UPDATE_REQUEST = 'APP_UPDATE_REQUEST'
export const APP_UPDATE_SUCCESS = 'APP_UPDATE_SUCCESS'
export const APP_UPDATE_FAILURE = 'APP_UPDATE_FAILURE'

export const APP_LIST_REQUEST = 'APP_LIST_REQUEST'
export const APP_LIST_SUCCESS = 'APP_LIST_SUCCESS'
export const APP_LIST_FAILURE = 'APP_LIST_FAILURE'

export const INSTALLED_APP_LIST_REQUEST = 'INSTALLED_APP_LIST_REQUEST'
export const INSTALLED_APP_LIST_SUCCESS = 'INSTALLED_APP_LIST_SUCCESS'
export const INSTALLED_APP_LIST_FAILURE = 'INSTALLED_APP_LIST_FAILURE'

export const APP_INSTALL_REQUEST = 'APP_INSTALL_REQUEST'
export const APP_INSTALL_SUCCESS = 'APP_INSTALL_SUCCESS'
export const APP_INSTALL_FAILURE = 'APP_INSTALL_FAILURE'

export const APP_UNINSTALL_REQUEST = 'APP_UNINSTALL_REQUEST'
export const APP_UNINSTALL_SUCCESS = 'APP_UNINSTALL_SUCCESS'
export const APP_UNINSTALL_FAILURE = 'APP_UNINSTALL_FAILURE'

export const SUBMISSION_CREATE_REQUEST = 'SUBMISSION_CREATE_REQUEST'
export const SUBMISSION_CREATE_SUCCESS = 'SUBMISSION_CREATE_SUCCESS'
export const SUBMISSION_CREATE_FAILURE = 'SUBMISSION_CREATE_FAILURE'

export const SUBMISSION_CANCEL_REQUEST = 'SUBMISSION_CANCEL_REQUEST'
export const SUBMISSION_CANCEL_SUCCESS = 'SUBMISSION_CANCEL_SUCCESS'
export const SUBMISSION_CANCEL_FAILURE = 'SUBMISSION_CANCEL_FAILURE'

export const SUBMISSION_LIST_REQUEST = 'SUBMISSION_LIST_REQUEST'
export const SUBMISSION_LIST_SUCCESS = 'SUBMISSION_LIST_SUCCESS'
export const SUBMISSION_LIST_FAILURE = 'SUBMISSION_LIST_FAILURE'

export const APP_PUBLISH_REQUEST = 'APP_PUBLISH_REQUEST'
export const APP_PUBLISH_SUCCESS = 'APP_PUBLISH_SUCCESS'
export const APP_PUBLISH_FAILURE = 'APP_PUBLISH_FAILURE'

export const APP_UNPUBLISH_REQUEST = 'APP_UNPUBLISH_REQUEST'
export const APP_UNPUBLISH_SUCCESS = 'APP_UNPUBLISH_SUCCESS'
export const APP_UNPUBLISH_FAILURE = 'APP_UNPUBLISH_FAILURE'

// UPLOADS
export const FILE_UPLOAD_REQUEST = 'FILE_UPLOAD_REQUEST'
export const FILE_UPLOAD_SUCCESS = 'FILE_UPLOAD_SUCCESS'
export const FILE_UPLOAD_FAILURE = 'FILE_UPLOAD_FAILURE'
export const FILE_UPLOAD_CLEAR = 'FILE_UPLOAD_CLEAR'



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js